import { store, getContext, getElement } from "@wordpress/interactivity";

function normalize(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

store("sviluppoecrescita/instant-search", {
  actions: {
    onSearch(e) {
      const ctx = getContext();
      const query = e.target.value;

      ctx.query = query;
      ctx.hasSearched = query.trim().length > 0;

      if (!ctx.hasSearched) {
        ctx.results = [];
        updateDOM(ctx);
        return;
      }

      const needle = normalize(query);

      ctx.results = ctx.posts.filter(
        (post) =>
          normalize(post.titolo).includes(needle) ||
          normalize(post.excerpt).includes(needle),
      );

      updateDOM(ctx);
    },

    clearSearch() {
      const ctx = getContext();
      ctx.query = "";
      ctx.hasSearched = false;
      ctx.results = [];

      const { ref } = getElement();
      const wrapper = ref.closest("[data-wp-interactive]");
      if (wrapper) {
        const input = wrapper.querySelector(".instant-search__input");
        if (input) input.value = "";
      }

      updateDOM(ctx);
    },
  },
});

function updateDOM(ctx) {
  const wrappers = document.querySelectorAll(
    '[data-wp-interactive="sviluppoecrescita/instant-search"]',
  );

  wrappers.forEach((wrapper) => {
    const resultsWrap = wrapper.querySelector(
      ".instant-search__results-wrapper",
    );
    const emptyMsg = wrapper.querySelector(".instant-search__empty");
    const groups = wrapper.querySelectorAll(".instant-search__group");
    const clearBtn = wrapper.querySelector(".instant-search__clear");

    // Mostra/nasconde il contenitore risultati
    if (resultsWrap) resultsWrap.hidden = !ctx.hasSearched;

    // Aggiorna bottone clear
    if (clearBtn) clearBtn.hidden = !ctx.query;

    if (!ctx.hasSearched) {
      groups.forEach((g) => (g.hidden = true));
      if (emptyMsg) emptyMsg.hidden = true;
      return;
    }

    const resultIds = new Set(ctx.results.map((p) => p.id));
    let totalVisible = 0;

    // Per ogni gruppo (tipo di post)
    groups.forEach((group) => {
      const type = group.dataset.postType;
      const items = group.querySelectorAll(".instant-search__item");
      let groupVisible = 0;

      items.forEach((item) => {
        const id = parseInt(item.dataset.postId, 10);
        const visible = resultIds.has(id);
        item.style.display = visible ? "" : "none";
        if (visible) groupVisible++;
      });

      // Mostra il gruppo solo se ha risultati
      group.hidden = groupVisible === 0;
      totalVisible += groupVisible;
    });

    // Messaggio nessun risultato
    if (emptyMsg) emptyMsg.hidden = totalVisible > 0;
  });
}
